import { InputsWrapper } from "components/FilterSlider/elements/InputsWrapper";
import { StyledSlider } from "components/FilterSlider/elements/StyledSlider";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Range from "rc-slider/lib/Range";
import { FilterNumberInput } from "components/FilterNumberInput";
import { FilterHistogram } from "components/FilterHistogram";
import { DL_FILTER_ACTION_ON, DL_FILTER_EVENT } from "helpers/constants";
import { useField } from "lib/form";
import { datalayerWrapper } from "lib/analytics/datalayerHelpers";

export function FilterSlider({
    subFilters,
    handleChange,
    aggregations,
    dataTestId = "filter-slider"
}) {
    const defaultRange = ["0", "101000"];
    const defaultStep = 1000;
    const [valueMax] = useField("maximumprijs");
    const [valueMin] = useField("minimumprijs");

    const emptyToDefault = (array) =>
        array.map((i, index) => (i.length > 0 ? i : defaultRange[index]));
    const [sliderRange, setSliderRange] = useState(emptyToDefault([valueMin, valueMax]));

    useEffect(() => {
        setSliderRange(emptyToDefault([valueMin, valueMax]));
    }, [valueMax, valueMin]);

    const getValueToUpdate = (priceValue) => {
        const stringValue = String(priceValue);
        if (stringValue.length > 0 && !defaultRange.includes(stringValue)) {
            return [priceValue];
        }

        return [];
    };

    const getInputValues = (priceValue) => {
        if (priceValue.length === 0) {
            return [""];
        }
        const newValue = String(priceValue[0]);
        if (defaultRange.includes(newValue)) {
            return [""];
        }
        return [newValue];
    };

    const handleInputChange = (filterId, price) => {
        handleChange(filterId, getValueToUpdate(price));
    };

    const updateFilters = (array) => {
        subFilters.forEach((filter, index) => {
            const { id, datalayerKey, seSubParam } = filter;
            const input = array[index];
            const currentValue = seSubParam === "min" ? Number(valueMin) : Number(valueMax);

            if (input !== currentValue) {
                const newValue = getValueToUpdate(input);
                handleChange(id, newValue);

                datalayerWrapper({
                    event: DL_FILTER_EVENT,
                    filter_action: DL_FILTER_ACTION_ON,
                    filter_name: datalayerKey,
                    filter_value: newValue
                });
            }
        });
    };

    return (
        <>
            <InputsWrapper>
                {subFilters.map(({ id, helpText, seSubParam, param, ariaLabel }) => {
                    return (
                        <FilterNumberInput
                            handleChange={handleInputChange}
                            key={id}
                            value={
                                seSubParam === "min"
                                    ? getInputValues(valueMin)
                                    : getInputValues(valueMax)
                            }
                            filterId={id}
                            datalayerKey={param}
                            helpText={helpText}
                            ariaLabel={ariaLabel}
                            numeric
                        />
                    );
                })}
            </InputsWrapper>
            <div data-testid={dataTestId}>
                {aggregations && (
                    <FilterHistogram
                        counts={aggregations}
                        range={sliderRange}
                        bucketsNumber={100}
                        bucketInterval={defaultStep}
                    />
                )}
                <StyledSlider>
                    <Range
                        onAfterChange={updateFilters}
                        value={sliderRange}
                        min={0}
                        max={101000}
                        step={defaultStep}
                        onChange={setSliderRange}
                    />
                </StyledSlider>
            </div>
        </>
    );
}

FilterSlider.propTypes = {
    handleChange: PropTypes.func.isRequired
};
